/*
 * @Author: Ryan
 * @Date: 2026-01-21
 * @Description: 写入目标页面 Store 的工具函数
 */

import { useProductAvatarStore } from '@/3.0/ai-product-avatar/store';
import { useTextToImageStore } from '@/3.0/image-generator/store/textToImageStore';
import { useImageToVideoStore } from '@/3.0/video-generation/store/imageToVideoStore';
import { useTextToVideoStore } from '@/3.0/video-generation/store/textToVideoStore';
import { ExtendedUploadFile, FILE_STATUS } from '@/components/FileUpload';

import { useUGCNavigationStore } from '../store';

/**
 * 将数据写入目标页面的 store
 * @param targetKey - 目标类型 key
 * @param prompt - 文本提示词
 * @param fileList - 上传的文件列表
 * @param hasUploadedImage - 是否有上传图片（决定写入文生还是图生 store）
 */
export const writeToTargetStore = (
  targetKey: string,
  prompt: string,
  fileList: ExtendedUploadFile[],
  hasUploadedImage: boolean,
) => {
  // 过滤出上传成功的文件
  const successFiles = fileList.filter((f) => f.status === FILE_STATUS.SUCCESS);

  // Product Photo Suite -> ai-product-avatar 产品区域
  if (targetKey === 'product-photo-suite') {
    useProductAvatarStore.getState().setScript(prompt);
    if (successFiles[0]) {
      useProductAvatarStore.getState().setProductInfo({
        url: successFiles[0].url!,
        previewUrl: successFiles[0].url!,
        name: successFiles[0].name,
      });
    }
    return;
  }

  // AI Avatar -> ai-product-avatar 数字人区域
  if (targetKey === 'ai-avatar') {
    useProductAvatarStore.getState().setScript(prompt);
    if (successFiles[0]) {
      useProductAvatarStore.getState().setAvatarInfo({
        url: successFiles[0].url!,
        previewUrl: successFiles[0].url!,
        title: successFiles[0].name,
      });
    }
    return;
  }

  // UGC Video Ads -> ai-video-generator
  if (targetKey === 'ugc-video-ads') {
    if (hasUploadedImage) {
      useImageToVideoStore.getState().setFormValues({
        prompt,
        image: successFiles,
      });
    } else {
      useTextToVideoStore.getState().setFormValues({ prompt });
    }
    return;
  }

  // Create Product Photo / Create image -> ai-image-generator
  if (targetKey === 'create-product-photo' || targetKey === 'create-image') {
    if (hasUploadedImage) {
      // 使用 UGCNavigationStore 传递数据（方案 B）
      // 注意：模型配置中字段名是 images（复数）
      useUGCNavigationStore.getState().setNavigationData('image-to-image', {
        prompt,
        images: successFiles,
      });
    } else {
      useTextToImageStore.getState().setFormValues({ prompt });
    }
    return;
  }
};
